import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/centerLogo.png'


const _withScopeId = n => (_pushScopeId("data-v-6fafb7fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal modal-sm"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"modalInner\" data-v-6fafb7fd><div class=\"modalHeader\" data-v-6fafb7fd><div class=\"centerLogo\" data-v-6fafb7fd><img src=\"" + _imports_0 + "\" alt=\"\" data-v-6fafb7fd></div></div><div class=\"info\" data-v-6fafb7fd><p class=\"dark\" data-v-6fafb7fd>Please rotate your device to landscape to play the game.</p></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showModal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}